import { defineComponent as _defineComponent } from 'vue'
import DocumentRender from '@/components/DocumentRender.vue'
    import { ref } from 'vue'
    import { log } from '../utils/logger'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentRenderLink',
  props: {
    docType: null,
    title: null,
    ssnProtected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
            docType: string
            title: string
            ssnProtected?: boolean
        }

    

    const showModal = ref(false)

    const handleClick = () => {
        log.info('DocumentRenderLink clicked')
        showModal.value = true
    }

return { __sfc: true,props, showModal, handleClick, DocumentRender }
}

})